<template>
    <div>
        <el-upload
                class="avatar-uploader"
                :action="uploadAction"
                :show-file-list="false"
                :on-success="handleAvatarScucess"
                :before-upload="beforeAvatarUpload"
                :on-progress="progressing"
                :on-error="onError"
        >
            <img v-if="longUrl" :src="longUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-if="value" class="avatar-left">
            <a href="javascript:" @click="enlargePic"><i class="avatar-view" :class="enlargIcon"></i></a>
        </div>
    </div>
</template>

<script>
    import util from '../common/util'
    export default {
       props: {
           value: {
               type:String,
               default:""
           },
           disabled:{
               type:Boolean,
               default:false
           },
           fileType:String
       },
       data(){
           return {
               uploadAction:global.serverHost+"server/system/upload.aspx",
               dialogVisible:false,
               loading:false
           }
        },
        computed: {
            enlargIcon(){
                if(this.value){
                    if(this.value.slice(-4)==".mp4" || this.value.slice(-4)==".flv" ||
                      this.value.slice(-4)==".avi" || this.value.slice(-4)==".pdf"){
                        return "el-icon-caret-right"
                    }else{
                        return "el-icon-caret-bottom"
                    }
                }
            },
            longUrl() {
                if(this.loading){
                    return global.serverHost + "images/loading.gif"
                }
                else if(this.value){
                    if(this.value.slice(-4)==".jpg" || this.value.slice(-5)==".jpge" || this.value.slice(-4)==".png"){
                        return global.serverHost + "upload/" + this.value
                    }else if(this.value.slice(-4)==".pdf"){
                        return global.serverHost + "images/pdf.jpg"
                    }else if(this.value.slice(-4)==".doc" || this.value.slice(-5)==".docx"){
                        return global.serverHost + "images/word.jpg"
                    }else if(this.value.slice(-4)==".xls" || this.value.slice(-5)==".xlsx"){
                        return global.serverHost + "images/excel.jpg"
                    }else if(this.value.slice(-4)==".mp4" || this.value.slice(-4)==".flv" || this.value.slice(-4)==".avi"){
                        return global.serverHost + "images/video.jpg"
                    }else{
                        return global.serverHost + "images/otherdoc.jpg"
                    }
                }else{
                    return ""
                }
            }
        },
        methods:{
            enlargePic:function () {
                let r = {}
                if(!util.emit(this,"onView",r)){
                      return
                }
                window.open(global.serverHost+ "upload/" + this.value)
            },
            handleAvatarScucess(res, file) {
                if(res && !res.success){
                    util.msg("上传出错:"+res.msg)
                }else{
                    this.$emit('input', res.filename)
                    this.$emit('onScucess', file)
                    util.msg("上传完成")
                    this.loading = false
                }
                //this.FLicensePic = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                let allow = true
                if(this.fileType){
                    allow = this.fileType.indexOf(file.type)>=0   //'application/pdf'
                }
                let isLt2M = (file.size / 1024 / 1024) < 1024*2
                if (!allow) {
                    this.$message.error('上传文件只能是 pdf 格式!')
                }
                if (!isLt2M) {
                    this.$message.error('上传pdf大小不能超过 2G!')
                }
                this.loading = allow && isLt2M
                return allow && isLt2M;
            },
            progressing(e,file){
                this.loading = true
            },
            onError(err){
                this.loading = false
            }
        }
    }
</script>


<style scoped>
    .avatar-uploader {
        width: 178px;
        height: 178px;
        border: 1px dashed #c0ccda;
        background-color: #fbfdff;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        float: left
    }

    .avatar-uploader:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
    }

    .avatar-view {
        font-size: 3.5em;
        color: gray;
    }

    .avatar-left{
        float: left;
        height: 178px;
        line-height:178px;
    }

</style>



// WEBPACK FOOTER //
// src/components/DocUpload.vue